import styles from "styles/pages/cdp/database-management.module.scss";

export default function MoveVariable({
  selectedItems,
  reset,
  openGroup,
  openRemove,
}) {
  return (
    <div className={styles.moveVariable}>
      <div className="d-flex align-center">
        <div className={styles.clear} onClick={reset}>
          <i className="fas fa-times" />
        </div>
        <p>{selectedItems.length} selecionado(s)</p>
      </div>
      <div className="d-flex align-center">
        {openRemove && (
          <div className={styles.remove} onClick={openRemove}>
            Remover
          </div>
        )}
        <div className={styles.move} onClick={openGroup}>
          Mover
        </div>
      </div>
    </div>
  );
}
